import React from 'react';

import './ContactLensCartCard.scss';

export const ContactLensCartCard = props => {
  const { key, product, onDeleteProduct } = props;

  const {
    name,
    price,
    image,
    powerAndBoxes,
    subTitle = null,
    pdf = null,
    isUploadPrescription = false,
  } = product;

  return (
    <div key={key} className="contact-lens-cart-card">
      <div className="contact-lens-cart-card__container">
        <img
          alt={name}
          className="contact-lens-cart-card__header-image contact-lens-cart-card__header-image-pc"
          src={image}
        />

        <div>
          <div className="contact-lens-cart-card__header">
            <img
              alt={name}
              className="contact-lens-cart-card__header-image contact-lens-cart-card__header-image-sp"
              src={image}
            />

            <div
              className="contact-lens-cart-card__header-text"
              data-is-align-to-top={Boolean(subTitle)}
            >
              <div>
                <h2 className="contact-lens-cart-card__header-name">{name}</h2>
                {subTitle && (
                  <span className="contact-lens-cart-card__header-sub-title">{subTitle}</span>
                )}
              </div>

              <p className="contact-lens-cart-card__header-price">{price}</p>
            </div>
          </div>

          <div className="contact-lens-cart-card__body">
            <h3 className="contact-lens-cart-card__power-and-boxes-title">Power and boxes</h3>

            <div className="contact-lens-cart-card__power-and-boxes-content">
              <div className="contact-lens-cart-card__power-and-boxes-content-header">
                <span>Eye</span>
                <span>Power</span>
                <span>Boxes</span>
              </div>

              <div className="contact-lens-cart-card__power-and-boxes-content-body">
                <div className="contact-lens-cart-card__power-and-boxes-content-body-item">
                  <span className="contact-lens-cart-card__power-and-boxes-content-body-item-eye">
                    L
                  </span>
                  <span className="contact-lens-cart-card__power-and-boxes-content-body-item-power">
                    {powerAndBoxes.left.power}
                  </span>
                  <span className="contact-lens-cart-card__power-and-boxes-content-body-item-box">
                    {powerAndBoxes.left.box}
                  </span>
                </div>

                <div className="contact-lens-cart-card__power-and-boxes-content-body-item">
                  <span className="contact-lens-cart-card__power-and-boxes-content-body-item-eye">
                    R
                  </span>
                  <span className="contact-lens-cart-card__power-and-boxes-content-body-item-power">
                    {powerAndBoxes.right.power}
                  </span>
                  <span className="contact-lens-cart-card__power-and-boxes-content-body-item-box">
                    {powerAndBoxes.right.box}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            className="contact-lens-cart-card__footer"
            data-is-space-between={Boolean(pdf) || isUploadPrescription}
          >
            {pdf && (
              <a
                className="contact-lens-cart-card__footer-pdf-text"
                href={pdf.url}
                rel="noreferrer"
                target="_blank"
              >
                {pdf.name}
              </a>
            )}

            {isUploadPrescription && (
              <p className="contact-lens-cart-card__footer-upload-prescription-text">
                Upload prescription after payment
              </p>
            )}

            <img
              alt="trash"
              className="contact-lens-cart-card__footer-trash"
              src="https://static.lenskart.com/owndays/img/contact-lens-pdp/icons/trash.svg"
              onClick={onDeleteProduct}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
